export default __webpack_public_path__ + "images/973847b17fa641d7eb4fd820c945da36.png";